import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { checkoutUrl, productPrice } from '../data/bonuses';
export function FinalCta() {
  return <section className="w-full bg-plum py-20 text-cream sm:py-28" aria-labelledby="final-title" data-id="element-55" data-mp="19epahm7xyuuw">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.6
    }} className="mx-auto w-full max-w-2xl px-5 text-center sm:px-8" data-id="element-56" data-mp="15ddkvgp2i9mp">
        <span className="text-xs font-medium uppercase tracking-[0.28em] text-blush" data-id="element-57" data-mp="1eds6yi9uvsr9">
          Y ahora…
        </span>
        <h2 id="final-title" className="mt-5 font-display text-3xl leading-tight sm:text-5xl" data-id="element-58" data-mp="1t4r9pco0fn2x">
          Algo dentro de ti ya sabe lo que tiene que hacer
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-cream/80" data-id="element-59" data-mp="2245xg4csljjq">
          Ese suspiro que acabas de dar es tu cuerpo diciendo que sí.
        </p>
        <p className="mt-3 font-display text-3xl italic text-blush" data-id="element-60" data-mp="n5ukpyj01hf6">Hazle caso.</p>

        <div className="mt-10 flex justify-center" data-id="element-61" data-mp="s4pchpyy2gbf">
          <CtaButton href={checkoutUrl} label={`Quiero mi eBook ahora — ${productPrice}`} sublabel="eBook + 6 bonos gratis · Descarga inmediata" data-id="element-62" data-mp="s5gyc92qozoi" />
        </div>

        <p className="mt-10 text-sm leading-relaxed text-cream/60" data-id="element-63" data-mp="124g8xx72f5e5">
          Todo descargable e instantáneo. Sin esperas, sin envíos, sin suscripciones.
        </p>
      </motion.div>
    </section>;
}